export { isValidWorkersCompCode } from '@careerstart/wae-common/schema/models/position-template/subSchemas/workersCompCodeSchema';

export const getId = (entity) => entity?._id || entity?.id;

export const toIds = (entities = []) => entities.map(getId);

export const getJurisdiction = (location) => location?.state || '';

export const countStates = (locations = []) =>
  new Set(locations.map(getJurisdiction).filter(Boolean)).size;

export const formatCurrency = (value) => (typeof value === 'number' ? `$${value.toFixed(2)}` : '—');

export const minutesToTimeString = (minutes) => {
  if (typeof minutes !== 'number') return '';
  const pad = (n) => `${n}`.padStart(2, '0');
  return `${pad(Math.floor(minutes / 60) % 24)}:${pad(minutes % 60)}`;
};

export const timeStringToMinutes = (time) => {
  const match = /^(\d{2}):(\d{2})$/.exec(time || '');
  return match ? Number(match[1]) * 60 + Number(match[2]) : null;
};
